import { ApiResult, request, safeRequest } from '@synergy/api';

import { FooterSettings } from '../models/footer-settings';

export class FooterSettingApi {
    constructor(protected baseUrl: string) {}

    public getFooterSettings(): Promise<ApiResult<FooterSettings>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/footer`),
            response => response.data
        );
    }

    public updateFooterLinks(links: FooterSettings): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/footer`, links),
            () => null
        );
    }
}
